<template>
  <div>
    <b-form-group label="Grupo Empresarial">
      <validation-provider
        #default="{ errors }"
        :rules="required ? 'required' : ''"
        name="'grupo Empresarial'"
      >
        <v-select
          ref="grupoEmpSelect"
          v-model="value_"
          :options="grupos"
          label="nome"
          :clearable="false"
          :multiple="multiple"
          @close="onTouch"
          @open="carregar"
          @search-change="carregarFiltrados"
          @input="enviarParaPai"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

  </div>
</template>

<script>
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import api from '@/app-modulo/comuns/grupo-empresarial/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'GrupoEmpresarialSelect',
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      requiredInner: required,
      valueAttr: null,
      foiAcessado: false,
      grupos: [],
      primeiroAcesso: true,
      filtro: [
        {
          colunas: ['Nome'],
          valor: null,
        },
      ],
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    isInvalid() {
      return this.invalid && this.foiAcessado
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueAttr = value
      }
    },
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    carregar() {
      if (this.primeiroAcesso) {
        api.getGruposEmpresariaisResumidos(this.filtro)
          .then(payload => {
            this.grupos = payload.data
            this.primeiroAcesso = false
          })
          .catch(err => {
            this.$errorFormated(err.response)
            throw err
          })
      }
    },
    carregarFiltrados(value) {
      this.filtro[0].valor = value

      api.getGruposEmpresariaisResumidos(this.filtro)
        .then(payload => {
          this.grupo = payload.data
        })
        .catch(err => {
          this.$errorFormated(err.response)
          throw err
        })
    },
    propagarParaFilho() {
      this.$refs.grupoEmpSelect.focus()
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    onTouch() {
      this.foiAcessado = true
    },
    limpar() {
      this.value_ = []
    },
  },
}
</script>
